export const DATADOG_LOG_EVENT = {
  QLIK_PARALLEL_SESSION: 'Qlik Sense Parallel Session',
  QLIK_CONNECTION_ERROR: 'Qlik Sense Connection Error',
  QLIK_SESSION_EXPIRATION: 'Qlik Sense Session Expired'
};
